<rt-heading variant="light heading large-xx" margin-bottom-small-x>
  {{ 'app.pricing.plan_picker.compare_our_pricing_plans' | translate }}
</rt-heading>

@for (comparison of content.comparisons; track trackByIndex($index)) {
  <div class="comparison">
    <div class="grid-cell">
      <rt-heading variant="heading large-x">{{ comparison.title }}</rt-heading>
    </div>
    <div class="grid-cell" text-center>
      <rt-heading variant="heading">
        {{
          (active === BillingPlanTier.Launch
            ? 'app.pricing.plan_picker.your_plan'
            : 'app.pricing.launch'
          ) | translate
        }}
      </rt-heading>
    </div>
    <div class="grid-cell" text-center>
      <rt-heading variant="heading">
        {{
          (active === BillingPlanTier.Scale
            ? 'app.pricing.plan_picker.your_plan'
            : 'app.pricing.scale'
          ) | translate
        }}
      </rt-heading>
    </div>
    <div class="grid-cell" text-center>
      <rt-heading variant="heading">
        {{
          (active === BillingPlanTier.Lead
            ? 'app.pricing.plan_picker.your_plan'
            : 'app.pricing.lead'
          ) | translate
        }}
      </rt-heading>
    </div>

    @for (item of comparison.items; track trackByIndex($index); let isLastRow = $last) {
      <div
        text-darkest
        class="grid-cell"
        [class.grid-cell--last-row]="isLastRow"
        layout-horizontal
        layout-align-items-center
      >
        <div>{{ item.title }}</div>
        @if (item.tooltip) {
          <rt-icon
            [rtTooltip]="item.tooltip"
            [rtTooltipPosition]="'right'"
            name="help-outline"
            margin-left-small-x
          ></rt-icon>
        }
      </div>
      @for (check of item.checklist; track trackByIndex(i); let i = $index) {
        <div
          [class.bg-launch]="check && i === 0 && highlighted === BillingPlanTier.Launch"
          [class.bg-scale]="check && i === 1 && highlighted === BillingPlanTier.Scale"
          [class.bg-lead]="check && i === 2 && highlighted === BillingPlanTier.Lead"
          [class.grid-cell--last-row]="isLastRow"
          class="grid-cell"
          text-darkest
        >
          @if (check) {
            <rt-icon name="check" size="medium"></rt-icon>
          }
        </div>
      }
    }
  </div>
}
